import { cn } from "@/lib/utils";
import { FileSearch } from "lucide-react";

interface EmptyStateProps {
    title?: string;
    description?: string;
    className?: string;
}

export const EmptyState = ({
    title = "No results found",
    description = "Try adjusting your filters to find what you are looking for.",
    className,
}: EmptyStateProps) => {
    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border/70 bg-secondary/30 px-6 py-10 text-center text-muted-foreground",
                className,
            )}
        >
            <FileSearch className="h-10 w-10 text-muted-foreground/70" />
            <div className="space-y-1">
                <h3 className="text-lg font-semibold text-foreground">{title}</h3>
                <p className="text-sm text-muted-foreground/80">{description}</p>
            </div>
        </div>
    );
};

